// Create an object to map MonogramFont values to image properties
const gloEmbMonogramCodelist = {
    '101MFloralLetter': {
        src: '//cdn.shopify.com/s/files/1/0635/8561/files/' + dec('U2FsdGVkX18zYu9i5aCVf2G9Y4KdI9sn2lGFKrVcV9/H0ViGAvtSUrOvJ/8TRY6n') + '.png?v=1706802902',
        code: 'U2FsdGVkX18zYu9i5aCVf2G9Y4KdI9sn2lGFKrVcV9/H0ViGAvtSUrOvJ/8TRY6n',
    },

    '101MGCoke': {
        src: '//cdn.shopify.com/s/files/1/0635/8561/files/' + dec('U2FsdGVkX1+Pjt9cJkDXU9699AKAJV3HNOb1cYgg9i0=') + '.png?v=1722354267',
        code: 'U2FsdGVkX1+Pjt9cJkDXU9699AKAJV3HNOb1cYgg9i0=',
    },

    '101MRatherBe': {
        src: '//cdn.shopify.com/s/files/1/0054/6819/2886/files/' + dec('U2FsdGVkX1+mFBTFF8l+951rgcxcGtSAh2+/n5B6H3M=') + '.png?v=1644974603',
        code: 'U2FsdGVkX1+mFBTFF8l+951rgcxcGtSAh2+/n5B6H3M=',
    },

    '101MTarget': {
        src: '//cdn.shopify.com/s/files/1/0054/6819/2886/files/' + dec('U2FsdGVkX19IZqpFEHmf8isRb02pAB55IIrxlOgTQzM=') + '.png?v=1644974590',
        code: 'U2FsdGVkX19IZqpFEHmf8isRb02pAB55IIrxlOgTQzM=',
    },

    '101MStarbucks': {
        src: '//cdn.shopify.com/s/files/1/0054/6819/2886/files/' + dec('U2FsdGVkX19YEqigK6RvWdROtvz/y6wozrXULfi9sWQ=') + '.png?v=1644974563',
        code: 'U2FsdGVkX19YEqigK6RvWdROtvz/y6wozrXULfi9sWQ=',
    },  


    '71MClassicSmiley': {
        src: '//cdn.shopify.com/s/files/1/0054/6819/2886/files/' + dec('U2FsdGVkX19DOtejkr7ssCuHLIU49hPq6LToY12linwfdo6/26mMsB/xbsO4sjEX') + '.png?v=1644974563',
        code: 'U2FsdGVkX19DOtejkr7ssCuHLIU49hPq6LToY12linwfdo6/26mMsB/xbsO4sjEX',
    },  


    '304MHappy': {
        src: '//cdn.shopify.com/s/files/1/0054/6819/2886/files/' + dec('U2FsdGVkX19M7LouA5QbcouLuONTtvHDVEXWjB/rdFU=') + '.png?v=1645849087',
        code: 'U2FsdGVkX19M7LouA5QbcouLuONTtvHDVEXWjB/rdFU=',
    },  


    '254MCharleston': {
        src: '//cdn.shopify.com/s/files/1/0054/6819/2886/files/' + dec('U2FsdGVkX18Yhg3t/H49mntRYsquzJBCi1JO+3p52vw=') + '.png?v=1645850218',
        code: 'U2FsdGVkX18Yhg3t/H49mntRYsquzJBCi1JO+3p52vw=',
    },  


    '89MCHS': {
        src: '//cdn.shopify.com/s/files/1/0054/6819/2886/files/' + dec('U2FsdGVkX19mlTAms34afbwOkuXjy5m+pBUXSl1Zs7c=') + '.png?v=1645853203',
        code: 'U2FsdGVkX19mlTAms34afbwOkuXjy5m+pBUXSl1Zs7c=',
    },  

    '101MGoodEnergyClub': {
        src: '//cdn.shopify.com/s/files/1/0054/6819/2886/files/' + dec('U2FsdGVkX1/wa6XTwLnO6jZ4IQlvAheMhf71/FuzYBA=') + '.png?v=1646992828',
        code: 'U2FsdGVkX18h//1lMywnksxJwMbMEIrEQQPhGenEMu42CrwX6eKZSKsqkZpDyGlR',
    },  


    '254IcedCaramel': {
        src: '//cdn.shopify.com/s/files/1/0054/6819/2886/files/' + dec('U2FsdGVkX19+kSaqyVdeIp2OtSL+erlI8aNOoduuVmA=') + '.png?v=1648397891',
        code: 'U2FsdGVkX19+kSaqyVdeIp2OtSL+erlI8aNOoduuVmA=',
    },  

 

    '101MAngelNumbers': {
        src: '//cdn.shopify.com/s/files/1/0054/6819/2886/files/' + dec('U2FsdGVkX1+bE4tLqNpn2AqxdYLgcQNvXmDCuogb8qzy9Mv/m823fFrWvoMk8h+s') + '.png?v=1648397879',
        code: 'U2FsdGVkX1+bE4tLqNpn2AqxdYLgcQNvXmDCuogb8qzy9Mv/m823fFrWvoMk8h+s',
    },  

    '177MRatherXmas': {
        src: '//cdn.shopify.com/s/files/1/0054/6819/2886/files/' + dec('U2FsdGVkX1/VSbkYu87xBcgDKPje6V1DHlfxWHUSAFY=') + 'Shop.png?v=1667412947',
        code: 'U2FsdGVkX1/VSbkYu87xBcgDKPje6V1DHlfxWHUSAFY=',
    },  

    '101MDisney': {
        src: '//cdn.shopify.com/s/files/1/0054/6819/2886/files/' + dec('U2FsdGVkX1+mFBTFF8l+951rgcxcGtSAh2+/n5B6H3M=') + '.png?v=1644974603',
        code: 'U2FsdGVkX1/TA6M5Xp31gbq9LnS95siVRHefod7hLfc=',
    },  

    '177MWifey': {
        src: '//cdn.shopify.com/s/files/1/0682/8923/3182/files/' + dec('U2FsdGVkX18rCrFRPdbYZWJ9vgJLE+2RHnabBskjYP4=') + '.png?v=1676904117',
        code: 'U2FsdGVkX18rCrFRPdbYZWJ9vgJLE+2RHnabBskjYP4=',
    },  


    '101MVinSanta1': {
        src: '//cdn.shopify.com/s/files/1/0635/8561/files/' + dec('U2FsdGVkX18WAgV+JbUp7WTwau/tEPW6+dTHJ/4RxAM=') + '.png?v=1698834583',
        code: 'U2FsdGVkX18WAgV+JbUp7WTwau/tEPW6+dTHJ/4RxAM=',
    },  
   
    '101MGrCoke': {
        src: '//cdn.shopify.com/s/files/1/0635/8561/files/' + dec('U2FsdGVkX19ydpuu3laivIzWNKJahA/UV+1c5ZlkdGQ=') + '.png?v=1699107084',
        code: 'U2FsdGVkX19ydpuu3laivIzWNKJahA/UV+1c5ZlkdGQ=',
    },  
    
    '200MCozy': {
        src: '//cdn.shopify.com/s/files/1/0635/8561/files/' + dec('U2FsdGVkX19ubV1xTjUOs9swRfNzCd0T41zLksZ5j40=') + '.png?v=1722440462',
        code: 'U2FsdGVkX19ubV1xTjUOs9swRfNzCd0T41zLksZ5j40=',
    },  
 



};